import { IOption } from '@/interfaces/option/option.interface'

export const hasObjectWithValue = (arr: IOption[], key: string, value: string) => {
  return arr.some((obj) => obj[key] === value)
}
